import { INCOME_RECIEVED, INCOME_SAVED, INCOME_DELETED, INCOME_UNLOADED } from './types'

export default function income(state = [], action = {}){
  switch (action.type) {
    case INCOME_RECIEVED:
      return action.data.sort(function(a, b) {
        let result = 0 
        let aStart = a.bars && a.bars[0] ? parseInt(a.bars[0].startDate, 10) : 0
        let bStart = b.bars && b.bars[0] ? parseInt(b.bars[0].startDate, 10) : 0
        let aValue = a.bars && a.bars[0] ? parseInt(a.bars[0].value, 10) : 0
        let bValue = b.bars && b.bars[0] ? parseInt(b.bars[0].value, 10) : 0
        let aAlloc = parseFloat(a.allocation)
        let bAlloc = parseFloat(b.allocation)
        aAlloc += (aAlloc > 0 && aAlloc < 1) ? 0 : 1
        bAlloc += (bAlloc > 0 && bAlloc < 1) ? 0 : 1     
        let aPayout = a.itemType==="payout" ? 10 : 0
        let bPayout = b.itemType==="payout" ? 10 : 0
        result = (aPayout - bPayout) || (bAlloc - aAlloc) || (a.itemType.localeCompare(b.itemType)) || (aStart-bStart) || (bValue - aValue) || (a.description.localeCompare(b.description))
        return result
      })
    case INCOME_UNLOADED:
      return []
    case INCOME_SAVED:
    let isEdit = false
    const _state = state.map( v => {
      if(v.id === action.data.id){
        isEdit = true
        return action.data
      }else{
        return v
      }
    })
    if(!isEdit){
      return [action.data, ...state]
    }else{
      return _state
    }
    case INCOME_DELETED:
      return state.filter( v => v.id !== action.data.id )
    default:
      return state
  }
}
